import React from 'react';
import loadable from '@loadable/component'
/**
 * The theme components only imports it's theme CSS-file. These components are lazy
 * loaded, to enable "code splitting" (in order to avoid the themes being bundled together)
 */
const Theme1 = loadable(() => import('./ArkaStudio'));
const Theme2 = loadable(() => import('./Hub'));
const href = window.location.href;

const hubTheme = href.search('hub');
const ThemeSelector: any = ({ children }) => (
  <>
    {/* Conditionally render theme, based on the current client context */}
    
      {hubTheme === -1 && <Theme1 />}
      {hubTheme !== -1 && <Theme2 />}
    
    {/* Render children immediately! */}
    {children}
  </>
);

export default ThemeSelector;



// WEBPACK FOOTER //
// ./src/components/themes/ThemeSelector.tsx